import { render, staticRenderFns } from "./ReturnBillItem.vue?vue&type=template&id=32b2973a"
import script from "./ReturnBillItem.vue?vue&type=script&lang=js"
export * from "./ReturnBillItem.vue?vue&type=script&lang=js"
import style0 from "./ReturnBillItem.vue?vue&type=style&index=0&id=32b2973a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports